import React, { forwardRef, useEffect, useImperativeHandle, useMemo } from 'react'
import { isNullable, isNullableWithZero, onlyNumeric } from '../../../../commonClass/CommonValidation';
import CustomColumn from '../../../../../customControl/CustomColumn';
import Select from 'react-select';

const ActivityPricingSection = forwardRef((
    {
        PricingForm,
        setPricingForm,
        defaultUserPricing,
        UserPricingForm,
        setUserPricingForm,
        setAdultPricingForm,
        ChildPricingForm,
        setChildPricingForm,
        // UnitPricingForm,
        // setUnitPricingForm,
        defaultPersonPricingForm,
        defaultUnitPricingForm,
        dropdownData,
        formErrors,
        setFormErrors,
        disabled,
        setEditDisabled
    },
    ref
) => {

    const AdultDisabled = useMemo(() => {
        return ![1, 3]?.includes(PricingForm?.ActivityManagePaxTypeId) || isNullableWithZero?.includes(PricingForm?.PricingTypeId);
    }, [PricingForm?.ActivityManagePaxTypeId, PricingForm?.PricingTypeId])

    const ChildDisabled = useMemo(() => {
        return ![2, 3]?.includes(PricingForm?.ActivityManagePaxTypeId) || isNullableWithZero?.includes(PricingForm?.PricingTypeId);
    }, [PricingForm?.ActivityManagePaxTypeId, PricingForm?.PricingTypeId])

    const GroupDisabled = useMemo(() => {
        return !PricingForm?.IsGroupCapacity || isNullableWithZero?.includes(PricingForm?.PricingTypeId);
    }, [PricingForm?.IsGroupCapacity, PricingForm?.PricingTypeId])

    const isPricingTypeNull = useMemo(() => {
        return [0]?.includes(PricingForm?.PricingTypeId);
    }, [PricingForm?.PricingTypeId])

    const handleOnChange = (name, value) => {
        setEditDisabled(false);
        setFormErrors(null);

        if (name === "PricingTypeId") {
            setPricingForm((prev) => ({
                ...prev, PricingTypeId: value,
            }));
            if (value !== PricingForm?.PricingTypeId) {
                setPricingForm((prev) => ({
                    ...prev,
                    ActivityManagePaxTypeId: 0,
                    IsUnitPricing: false,
                    // MaximumPersonCapacity: null
                }));
                setUserPricingForm((prev) => ({
                    ...prev,
                    ActivityManagePaxTypeId: value,
                    adult: { ...defaultUserPricing, ActivityManagePaxTypeId: 1 },
                    child: { ...defaultUserPricing, ActivityManagePaxTypeId: 2 },
                    Group: { ...defaultUserPricing, ActivityManagePaxTypeId: 3, MaximumPersonCapacity: null },
                }))
            }
        }
        else if (name === "ActivityManagePaxTypeId") {
            setPricingForm((prev) => ({
                ...prev, ActivityManagePaxTypeId: value,
            }));
            if (value !== PricingForm?.ActivityManagePaxTypeId) {
                setUserPricingForm((prev) => ({
                    ...prev,
                    ActivityManagePaxTypeId: value,
                    adult: { ...defaultUserPricing, ActivityManagePaxTypeId: 1 },
                    child: { ...defaultUserPricing, ActivityManagePaxTypeId: 2 },
                    Group: { ...defaultUserPricing, ActivityManagePaxTypeId: 3, MaximumPersonCapacity: null },
                }))
            }
        }
        else {
            setPricingForm((prev) => ({ ...prev, [name]: value }));
        }
        
        if (name === "IsGroupCapacity") {
            setUserPricingForm((prev) => ({
                ...prev,
                ActivityManagePaxTypeId: value,
                adult: { ...defaultUserPricing, ActivityManagePaxTypeId: 1 },
                child: { ...defaultUserPricing, ActivityManagePaxTypeId: 2 },
                Group: { ...defaultUserPricing, ActivityManagePaxTypeId: 3, MaximumPersonCapacity: null },
            }))
        }
    }

    const handlePriceChange = (type, name, value) => {
        setEditDisabled(false);
        setFormErrors(null);

        setUserPricingForm((prev) => ({
            ...prev,
            [type]: { ...prev?.[type], [name]: value }
        }))
    }

    const roundValue = (num) => { return Number(Math.round(Number(num))); }

    const getAmountOfPercentage = (isPercenatge, basePrice, value) => {
        const amount = isPercenatge ? ((basePrice * value) / 100) : value;
        return roundValue(amount);
    }

    const priceCalculation = (
        ActivityManagePaxTypeId = 0,
        PricingTypeId,
        BasePriceString,
        ActivityManageTaxId,
        CommissionString,
        ETMMarkupString,
        orUnit = false
    ) => {

        // (Base price - Commission) + tax = Net Vendor Amount
        // Vendor Amount + (ETM Markup + Markup tax) = Display Amount

        let priceData = {};
        const BasePrice = BasePriceString ? roundValue(BasePriceString) : BasePriceString;
        const Commission = CommissionString ? roundValue(CommissionString) : CommissionString;
        const ETMMarkup = ETMMarkupString ? roundValue(ETMMarkupString) : ETMMarkupString;

        if (
            !isNullable?.includes(PricingTypeId) &&
            !isNullable?.includes(BasePrice) &&
            !isNullable?.includes(Commission) &&
            !isNullable?.includes(ETMMarkup) &&
            !isNullable?.includes(ActivityManageTaxId)
        ) {
            const isPercentage = PricingTypeId === 1 ? true : false;

            const TaxPercentage = dropdownData?.taxList?.find((prev) => prev?.value === ActivityManageTaxId)?.TaxValue;

            const CommissionAmount = getAmountOfPercentage(isPercentage, BasePrice, Commission);
            const BeforeTax = roundValue(BasePrice - CommissionAmount);
            const TaxPercentageAmount = getAmountOfPercentage(true, BeforeTax, TaxPercentage);

            const NetPrice = roundValue(BeforeTax + TaxPercentageAmount);

            const NetMarkupAmount = getAmountOfPercentage(isPercentage, NetPrice, ETMMarkup);
            const MarkupTax = getAmountOfPercentage(true, NetMarkupAmount, TaxPercentage);

            const DisplayPrice = roundValue(NetPrice + NetMarkupAmount + MarkupTax);

            priceData = {
                ActivityManagePaxTypeId,
                BasePrice,
                ActivityManageTaxId,
                TaxPercentage,
                TaxPercentageAmount,
                Commission,
                CommissionAmount,
                ETMMarkup,
                NetMarkupAmount,
                MarkupTax,
                NetPrice, DisplayPrice
            }
            // }
        }
        else {
            priceData = null
        }

        return priceData;
    }

    const GroupCalculate = useMemo(() => {
        const GroupData = priceCalculation(
            UserPricingForm?.Group?.ActivityManagePaxTypeId,
            PricingForm?.PricingTypeId,
            UserPricingForm?.Group?.BasePrice,
            UserPricingForm?.Group?.ActivityManageTaxId,
            UserPricingForm?.Group?.Commission,
            UserPricingForm?.Group?.ETMMarkup,
            true
        );
        GroupData && setUserPricingForm((prev) => ({ ...prev, Group: { ...prev.Group, ...GroupData } }))
        return GroupData
    }, [
        UserPricingForm?.Group?.BasePrice,
        UserPricingForm?.Group?.ActivityManageTaxId,
        UserPricingForm?.Group?.Commission,
        UserPricingForm?.Group?.ETMMarkup,
        PricingForm?.IsGroupCapacity

    ])

    const AdultCalculate = useMemo(() => {
        const AdultData = priceCalculation(
            UserPricingForm?.adult?.ActivityManagePaxTypeId,
            PricingForm?.PricingTypeId,
            UserPricingForm?.adult?.BasePrice,
            UserPricingForm?.adult?.ActivityManageTaxId,
            UserPricingForm?.adult?.Commission,
            UserPricingForm?.adult?.ETMMarkup,
            true
        );
        AdultData && setUserPricingForm((prev) => ({ ...prev, adult: { ...AdultData } }))
        return AdultData
    }, [
        UserPricingForm?.adult?.BasePrice,
        UserPricingForm?.adult?.ActivityManageTaxId,
        UserPricingForm?.adult?.Commission,
         UserPricingForm?.adult?.ETMMarkup,
        PricingForm?.IsGroupCapacity
    ])

    const ChildCalculate = useMemo(() => {
        const ChildData = priceCalculation(
            UserPricingForm?.child?.ActivityManagePaxTypeId,
            PricingForm?.PricingTypeId,
            UserPricingForm?.child?.BasePrice,
            UserPricingForm?.child?.ActivityManageTaxId,
            UserPricingForm?.child?.Commission,
            UserPricingForm?.child?.ETMMarkup,
            true
        );
        ChildData && setUserPricingForm((prev) => ({ ...prev, child: { ...ChildData } }))
        return ChildData
    }, [
        UserPricingForm?.child?.BasePrice,
        UserPricingForm?.child?.ActivityManageTaxId,
        UserPricingForm?.child?.Commission,
        UserPricingForm?.child?.ETMMarkup,
        PricingForm?.IsGroupCapacity
    ])

    const commonPaxTypeValidation = (type, error, priceColl) => {
        if (priceColl) {
            const keys = Object.keys(priceColl);

            keys?.forEach((key) => {
                const isCheck = key === "ActivityManageTaxId" ? isNullableWithZero : isNullable;
                if (isCheck?.includes(priceColl?.[key])) {
                    error[`${type}${key}`] = "Cannot leave blank";
                }
                if (key !== "ETMMarkup" && priceColl?.[key]?.toString()?.length > 6) {
                    error[`${type}${key}`] = "Max 6 digits allowed.";
                }
                if (key === "ETMMarkup" && priceColl?.[key]?.toString()?.length > 4) {
                    error[`${type}${key}`] = "Max 4 digits are allowed.";
                }
                if (Number(priceColl?.Commission) > Number(priceColl?.BasePrice)) {
                    error[`${type}Commission`] = "Commission cannot be more than Base price value.";
                }
            })
        }
    }


    const ValidatePricingForm = () => {
        let error = {};

        if (PricingForm?.PricingTypeId === 0 || PricingForm?.PricingTypeId === null) {
            error.PricingTypeId = "Please select Pricing type";
        }
        else {
            if (PricingForm?.ActivityManagePaxTypeId === 0 || PricingForm?.ActivityManagePaxTypeId === null) {
                error.ActivityManagePaxTypeId = "Input Is mandatory , Cannot leave blank.";
            }
            else if (PricingForm?.ActivityManagePaxTypeId === 1 && !PricingForm?.IsGroupCapacity) {
                commonPaxTypeValidation("adult", error, UserPricingForm?.adult);
            }
            else if (PricingForm?.ActivityManagePaxTypeId === 2 && !PricingForm?.IsGroupCapacity) {
                commonPaxTypeValidation("child", error, UserPricingForm?.child);
            }
            else if (PricingForm?.ActivityManagePaxTypeId === 3 && !PricingForm?.IsGroupCapacity) {
                commonPaxTypeValidation("adult", error, UserPricingForm?.adult);
                commonPaxTypeValidation("child", error, UserPricingForm?.child);
            }

            if (PricingForm?.IsGroupCapacity) {
                if (isNullable?.includes(UserPricingForm?.Group?.MaximumPersonCapacity)) {
                    error.MaximumPersonCapacity = "Input Is mandatory , Cannot leave blank.";
                }
                else if (UserPricingForm?.Group?.MaximumPersonCapacity < 2) {
                    error.MaximumPersonCapacity = "Please provide value greater than 1.";
                }
                commonPaxTypeValidation("Group", error, UserPricingForm?.Group);
            }
        }

        return error;
    }

    // Expose the childFunction to the parent's ref
    useImperativeHandle(ref, () => ({
        canValidate: true,
        ValidatePricingForm: ValidatePricingForm
    }));

    return (
        <>
            <div className="row">
                <CustomColumn colXLNum={4} colNum={6} colMDNum={6} colLabel={6} colChildren={6} labelText='Pricing Type' labelId='PricingTypeId' isRequired >
                    <Select
                        className="dropdown select_dropdown"
                        inputId='PricingTypeId'
                        options={dropdownData?.policyTypeList}
                        value={dropdownData?.policyTypeList?.filter((prev) => prev?.value === PricingForm?.PricingTypeId) || null}
                        onChange={(e) => handleOnChange("PricingTypeId", e ? e?.value : 0)}
                        isSearchable
                        isDisabled={disabled ? true : false}
                        placeholder='Pricing Type'
                    />
                    {formErrors?.PricingTypeId && <div className="text-danger text-start fs_14">{formErrors?.PricingTypeId}</div>}
                </CustomColumn>

                <CustomColumn colXLNum={4} colNum={6} colMDNum={6} colLabel={6} colChildren={6} labelText='Is this Activity For' labelId='ActivityManagePaxTypeId' isRequired={PricingForm?.PricingTypeId !== 0} >
                    <Select
                        className="dropdown select_dropdown"
                        inputId='ActivityManagePaxTypeId'
                        options={dropdownData?.paxTypeList}
                        value={dropdownData?.paxTypeList?.find((prev) => prev?.value === PricingForm?.ActivityManagePaxTypeId) || 0}
                        onChange={(e) => handleOnChange("ActivityManagePaxTypeId", e ? e?.value : 0)}
                        isSearchable
                        isDisabled={disabled || isPricingTypeNull}
                        placeholder='Is this Activity For'
                    />
                    {formErrors?.ActivityManagePaxTypeId && <div className="text-danger text-start fs_14">{formErrors?.ActivityManagePaxTypeId}</div>}
                </CustomColumn>

                <CustomColumn colNum={4} classChildren="align-content-center" labelText='Schedule Activity' labelId='ScheduleActivity' classlabel="d-none">
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="form-check">
                                <input
                                    type="radio"
                                    id="IsGroupCapacityGroup"
                                    className="form-check-input"
                                    name="IsGroupCapacity"
                                    value={1}
                                    checked={PricingForm?.IsGroupCapacity === true ? true : false}
                                    onChange={() => handleOnChange('IsGroupCapacity', true)}
                                // disabled={disabled}
                                />
                                <label htmlFor="IsGroupCapacityGroup" className="form-check-label"> Group </label>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="form-check">
                                <input
                                    type="radio"
                                    id="IsGroupCapacitySingle"
                                    className="form-check-input"
                                    name="IsGroupCapacity"
                                    value={2}
                                    checked={PricingForm?.IsGroupCapacity === false ? true : false}
                                    onChange={() => handleOnChange('IsGroupCapacity', false)}
                                // disabled={disabled || (ActivityManagePricingId > 0 && IsScheduleActivity)}
                                />
                                <label htmlFor="IsGroupCapacitySingle" className="form-check-label"> Single </label>
                            </div>
                        </div>
                    </div>
                </CustomColumn>

                {/* Adult Pricing start */}
                <CustomColumn colNum={12} colLabel={2} colMDLabel={2} colXLChildren={8} colChildren={10} colMDChildren={10} classChildren="align-content-center" labelText='Adult' labelId='OperatedDays' isRequired={!AdultDisabled}>

                    <div className="row g-2 row-cols-2 row-cols-md-6 ">
                        <div className="col">
                            <input
                                className='form-control'
                                type="text"
                                name="adultBasePrice"
                                id="adultBasePrice"
                                value={UserPricingForm?.adult?.BasePrice ?? ""}
                                onChange={(e) => {
                                    const numberValue = onlyNumeric(e.target.value) && Number(onlyNumeric(e.target.value))
                                    e?.target?.value?.length <= 6 &&
                                        handlePriceChange("adult", "BasePrice", numberValue)
                                }}
                                maxLength={6}
                                disabled={disabled || AdultDisabled || PricingForm.IsGroupCapacity}
                                placeholder='Base Price'
                            />
                            {formErrors?.adultBasePrice && <div className="text-danger text-start fs_14">{formErrors?.adultBasePrice}</div>}
                        </div>
                        <div className="col">
                            <Select
                                className="dropdown select_dropdown"
                                inputId='adultActivityManageTaxId'
                                options={dropdownData?.taxList}
                                value={dropdownData?.taxList?.find((prev) => prev?.value === UserPricingForm?.adult?.ActivityManageTaxId) || 0}
                                onChange={(e) => handlePriceChange("adult", "ActivityManageTaxId", e ? e?.value : 0)}
                                isSearchable
                                isDisabled={disabled || AdultDisabled || PricingForm.IsGroupCapacity}
                                placeholder='Tax'
                            />
                            {formErrors?.adultActivityManageTaxId && <div className="text-danger text-start fs_14">{formErrors?.adultActivityManageTaxId}</div>}
                        </div>
                        <div className="col">
                            <input
                                className='form-control'
                                type="text"
                                name="adultCommission"
                                id="adultCommission"
                                value={UserPricingForm?.adult?.Commission ?? ""}
                                onChange={(e) => {
                                    const numberValue = onlyNumeric(e.target.value) && Number(onlyNumeric(e.target.value))
                                    if (PricingForm?.PricingTypeId === 1) {
                                        numberValue <= 100 &&
                                            handlePriceChange("adult", "Commission", numberValue)
                                    }
                                    else {
                                        e?.target?.value?.length <= 6 &&
                                            handlePriceChange("adult", "Commission", numberValue)
                                    }
                                }}
                                maxLength={PricingForm?.PricingTypeId === 1 ? 3 : 6}
                                disabled={disabled || AdultDisabled || PricingForm.IsGroupCapacity}
                                placeholder='Commission'
                            />
                            {formErrors?.adultCommission && <div className="text-danger text-start fs_14">{formErrors?.adultCommission}</div>}
                        </div>
                        <div className="col">
                            <input
                                className='form-control'
                                type="text"
                                name="adultETMMarkup"
                                id="adultETMMarkup"
                                value={UserPricingForm?.adult?.ETMMarkup ?? ""}
                                onChange={(e) => {
                                    const numberValue = onlyNumeric(e.target.value) && Number(onlyNumeric(e.target.value))
                                    if (PricingForm?.PricingTypeId === 1) {
                                        numberValue <= 100 &&
                                            handlePriceChange("adult", "ETMMarkup", numberValue)
                                    }
                                    else {
                                        e?.target?.value?.length <= 4 &&
                                            handlePriceChange("adult", "ETMMarkup", numberValue)
                                    }
                                }}
                                maxLength={PricingForm?.PricingTypeId === 1 ? 3 : 4}
                                disabled={disabled || AdultDisabled || PricingForm.IsGroupCapacity}
                                placeholder='ETM Markup'
                            />
                            {formErrors?.adultETMMarkup && <div className="text-danger text-start fs_14">{formErrors?.adultETMMarkup}</div>}
                        </div>
                        <div className="col">
                            <input
                                className='form-control'
                                type="text"
                                value={AdultCalculate?.NetPrice ?? ""}
                                onChange={(e) => {
                                    const numberValue = onlyNumeric(e.target.value) && Number(onlyNumeric(e.target.value))
                                    e?.target?.value?.length <= 6 &&
                                        handlePriceChange("adult", "NetPrice", numberValue)
                                }}
                                maxLength={6}
                                disabled
                                placeholder='Net Price'
                            />
                        </div>
                        <div className="col">
                            <input
                                className='form-control'
                                type="text"
                                value={AdultCalculate?.DisplayPrice ?? ""}
                                // onChange={(e) => {
                                //     const numberValue = onlyNumeric(e.target.value) && Number(onlyNumeric(e.target.value))
                                //     e?.target?.value?.length <= 6 &&
                                //         handlePriceChange("adult", "DisplayPrice", numberValue)
                                // }}
                                maxLength={6}
                                disabled
                                placeholder='Display Price'
                            />
                        </div>
                    </div>

                </CustomColumn>
                {/* Adult Pricing end */}

                {/* Child Pricing start */}
                <CustomColumn colNum={12} colLabel={2} colMDLabel={2} colXLChildren={8} colChildren={10} colMDChildren={10} classChildren="align-content-center" labelText='Child' labelId='OperatedDays' isRequired={!ChildDisabled}>

                    <div className="row g-2 row-cols-2 row-cols-md-6 ">
                        <div className="col">
                            <input
                                className='form-control'
                                type="text"
                                name="childBasePrice"
                                id="childBasePrice"
                                value={UserPricingForm?.child?.BasePrice ?? ""}
                                onChange={(e) => {
                                    const numberValue = onlyNumeric(e.target.value) && Number(onlyNumeric(e.target.value))
                                    e?.target?.value?.length <= 6 &&
                                        handlePriceChange("child", "BasePrice", numberValue)
                                }}
                                maxLength={6}
                                disabled={disabled || ChildDisabled || PricingForm.IsGroupCapacity}
                                placeholder='Base Price'
                            />
                            {formErrors?.childBasePrice && <div className="text-danger text-start fs_14">{formErrors?.childBasePrice}</div>}
                        </div>
                        <div className="col">
                            <Select
                                className="dropdown select_dropdown"
                                inputId='childActivityManageTaxId'
                                options={dropdownData?.taxList}
                                value={dropdownData?.taxList?.find((prev) => prev?.value === UserPricingForm?.child?.ActivityManageTaxId) || 0}
                                onChange={(e) => handlePriceChange("child", "ActivityManageTaxId", e ? e?.value : 0)}
                                isSearchable
                                isDisabled={disabled || ChildDisabled || PricingForm.IsGroupCapacity}
                                placeholder='Tax'
                            />
                            {formErrors?.childActivityManageTaxId && <div className="text-danger text-start fs_14">{formErrors?.childActivityManageTaxId}</div>}
                        </div>
                        <div className="col">
                            <input
                                className='form-control'
                                type="text"
                                name="childCommission"
                                id="childCommission"
                                value={UserPricingForm?.child?.Commission ?? ""}
                                onChange={(e) => {
                                    const numberValue = onlyNumeric(e.target.value) && Number(onlyNumeric(e.target.value))
                                    if (PricingForm?.PricingTypeId === 1) {
                                        numberValue <= 100 &&
                                            handlePriceChange("child", "Commission", numberValue)
                                    }
                                    else {
                                        e?.target?.value?.length <= 6 &&
                                            handlePriceChange("child", "Commission", numberValue)
                                    }
                                }}
                                maxLength={PricingForm?.PricingTypeId === 1 ? 3 : 6}
                                disabled={disabled || ChildDisabled || PricingForm.IsGroupCapacity}
                                placeholder='Commission'
                            />
                            {formErrors?.childCommission && <div className="text-danger text-start fs_14">{formErrors?.childCommission}</div>}
                        </div>
                        <div className="col">
                            <input
                                className='form-control'
                                type="text"
                                name="childETMMarkup"
                                id="childETMMarkup"
                                value={UserPricingForm?.child?.ETMMarkup ?? ""}
                                onChange={(e) => {
                                    const numberValue = onlyNumeric(e.target.value) && Number(onlyNumeric(e.target.value))
                                    if (PricingForm?.PricingTypeId === 1) {
                                        numberValue <= 100 &&
                                            handlePriceChange("child", "ETMMarkup", numberValue)
                                    }
                                    else {
                                        e?.target?.value?.length <= 4 &&
                                            handlePriceChange("child", "ETMMarkup", numberValue)
                                    }
                                }}
                                maxLength={PricingForm?.PricingTypeId === 1 ? 3 : 4}
                                disabled={disabled || ChildDisabled || PricingForm.IsGroupCapacity}
                                placeholder='ETM Markup'
                            />
                            {formErrors?.childETMMarkup && <div className="text-danger text-start fs_14">{formErrors?.childETMMarkup}</div>}
                        </div>
                        <div className="col">
                            <input
                                className='form-control'
                                type="text"
                                value={ChildCalculate?.NetPrice ?? ""}
                                // onChange={() => { }}
                                maxLength={6}
                                disabled
                                placeholder='Net Price'
                            />
                        </div>
                        <div className="col">
                            <input
                                className='form-control'
                                type="text"
                                value={ChildCalculate?.DisplayPrice ?? ""}
                                // onChange={() => { }}
                                maxLength={6}
                                disabled
                                placeholder='Display Price'
                            />
                        </div>
                    </div>

                </CustomColumn>
                {/* Child Pricing end */}

                <CustomColumn colNum={4} colMDNum={6} colLabel={6} colChildren={6} labelText='Capacity of group' labelId='MaximumPersonCapacity' isRequired={!GroupDisabled} >
                    <input
                        type="text"
                        className='form-control'
                        name="MaximumPersonCapacity"
                        id="MaximumPersonCapacity"
                        placeholder='Enter Group Capacity'
                        value={UserPricingForm?.Group?.MaximumPersonCapacity ?? ""}
                        onChange={(e) => e.target.value?.length <= 3 && handlePriceChange("Group",
                            "MaximumPersonCapacity",
                            onlyNumeric(e.target.value) ? Number(e.target.value) : null
                        )}
                        disabled={disabled || !PricingForm.IsGroupCapacity}
                        maxLength={3}
                    />
                    {formErrors?.MaximumPersonCapacity && <div className="text-danger text-start fs_14">{formErrors?.MaximumPersonCapacity}</div>}
                </CustomColumn>

                <CustomColumn colNum={12} colLabel={2} colMDLabel={2} colXLChildren={8} colChildren={10} colMDChildren={10} classChildren="align-content-center" labelText='Pricing Per Group' labelId='OperatedDays' isRequired={!GroupDisabled}>

                    <div className="row g-2 row-cols-2 row-cols-md-6 ">
                        <div className="col">
                            <input
                                className='form-control'
                                type="text"
                                name="GroupBasePrice"
                                id="GroupBasePrice"
                                value={UserPricingForm?.Group?.BasePrice ?? ""}
                                onChange={(e) => {
                                    const numberValue = onlyNumeric(e.target.value) && Number(onlyNumeric(e.target.value))
                                    e?.target?.value?.length <= 6 &&
                                        handlePriceChange("Group", "BasePrice", numberValue)
                                }}
                                maxLength={6}
                                disabled={disabled || !PricingForm.IsGroupCapacity}
                                placeholder='Base Price'
                            />
                            {formErrors?.unitBasePrice && <div className="text-danger text-start fs_14">{formErrors?.unitBasePrice}</div>}
                        </div>
                        <div className="col">
                            <Select
                                className="dropdown select_dropdown"
                                inputId='GroupActivityManageTaxId'
                                options={dropdownData?.taxList}
                                value={dropdownData?.taxList?.find((prev) => prev?.value === UserPricingForm?.Group?.ActivityManageTaxId) || 0}
                                onChange={(e) => handlePriceChange("Group", "ActivityManageTaxId", e ? e?.value : 0)}
                                isSearchable
                                isDisabled={disabled || !PricingForm.IsGroupCapacity}
                                placeholder='Tax'
                            />
                            {formErrors?.unitActivityManageTaxId && <div className="text-danger text-start fs_14">{formErrors?.unitActivityManageTaxId}</div>}
                        </div>
                        <div className="col">
                            <input
                                className='form-control'
                                type="text"
                                name="GroupCommission"
                                id="GroupCommission"
                                value={UserPricingForm?.Group?.Commission ?? ""}
                                onChange={(e) => {
                                    const numberValue = onlyNumeric(e.target.value) && Number(onlyNumeric(e.target.value))
                                    if (PricingForm?.PricingTypeId === 1) {
                                        numberValue <= 100 &&
                                            handlePriceChange("Group", "Commission", numberValue)
                                    }
                                    else {
                                        e?.target?.value?.length <= 6 &&
                                            handlePriceChange("Group", "Commission", numberValue)
                                    }
                                }}
                                maxLength={PricingForm?.PricingTypeId === 1 ? 3 : 6}
                                disabled={disabled || !PricingForm.IsGroupCapacity}
                                placeholder='Commission'
                            />
                            {formErrors?.unitCommission && <div className="text-danger text-start fs_14">{formErrors?.unitCommission}</div>}
                        </div>
                        <div className="col">
                            <input
                                className='form-control'
                                type="text"
                                name="GroupETMMarkup"
                                id="GroupETMMarkup"
                                value={UserPricingForm?.Group?.ETMMarkup ?? ""}
                                onChange={(e) => {
                                    const numberValue = onlyNumeric(e.target.value) && Number(onlyNumeric(e.target.value))
                                    if (PricingForm?.PricingTypeId === 1) {
                                        numberValue <= 100 &&
                                            handlePriceChange("Group", "ETMMarkup", numberValue)
                                    }
                                    else {
                                        e?.target?.value?.length <= 4 &&
                                            handlePriceChange("Group", "ETMMarkup", numberValue)
                                    }
                                }}
                                maxLength={PricingForm?.PricingTypeId === 1 ? 3 : 4}
                                disabled={disabled || !PricingForm.IsGroupCapacity}
                                placeholder='ETM Markup'
                            />
                            {formErrors?.unitETMMarkup && <div className="text-danger text-start fs_14">{formErrors?.unitETMMarkup}</div>}
                        </div>
                        <div className="col">
                            <input
                                className='form-control'
                                type="text"
                                value={GroupCalculate?.NetPrice ?? ""}
                                onChange={() => { }}
                                maxLength={6}
                                disabled
                                placeholder='Net Price'
                            />
                        </div>
                        <div className="col">
                            <input
                                className='form-control'
                                type="text"
                                value={GroupCalculate?.DisplayPrice ?? ""}
                                onChange={() => { }}
                                maxLength={6}
                                disabled
                                placeholder='Display Price'
                            />
                        </div>
                    </div>

                </CustomColumn>
                {/* Unit Pricing and max person end */}

            </div>
        </>
    )
});

export default ActivityPricingSection